import React, { Component } from "react";
import SlideEvents3 from "../layout/SlideEvents3";

class Section5Academy extends Component {
  render() {
    return (
      <div
        id="Section5Academy"
        className="section content_container"
        style={{
          width: this.props.wd.ww,
          height: this.props.wd.sh / 2,
          marginTop: this.props.wd.sh / 2,
        }}
      >
        <div
          className="column left"
          style={{
            height: this.props.wd.sh,
            marginTop: -this.props.wd.sh / 2,
          }}
        >
          <SlideEvents3 openVideoModal={this.props.openVideoModal} />
        </div>
        <div className="column right" style={{ height: this.props.wd.sh / 2 }}>
          <div className="content">
            <img
              className="title title_sm"
              alt="Imagem do Título Farda"
              src="images/section5academy_lefttitle.png"
            />
            <p>
              A Academia Nelson Lopes já tem finalmente, camisolas oficiais. Não
              parece pelos tons cinzentos do site mas, são lindas e vistosas.
              Nada como vir, pessoalmete vê-las. Esperamos por si.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Section5Academy;
